import { createReducer, on } from '@ngrx/store';

import { goToProjects, setProject } from '../../core/store';
import {
	bulkDeleteMaps,
	deleteMap,
	deleteMapFail,
	deleteMapSuccess,
	fetchMapListFail,
	fetchMapListSuccess,
	initMapList,
	refreshMapList,
	updateIncludePublic,
} from './map.actions';
import { MapMainSliceState } from './map.state';

export const mapOriginalReducer = createReducer<MapMainSliceState>(
	new MapMainSliceState(),
	on(goToProjects, setProject, (state) => state.clear()),
	on(initMapList, refreshMapList, (state) => state.setLoading(true)),
	on(fetchMapListSuccess, (state, action) =>
		state.setLoading(false).setMapList(action.mapList)
	),
	on(deleteMap, bulkDeleteMaps, (state) => state.setLoading(true)),
	on(deleteMapSuccess, (state) => state.setDeleteSuccess(true)),
	on(deleteMapFail, (state) => state.setDeleteSuccess(false).setLoading(false)),
	on(fetchMapListFail, (state) => state.setLoading(false)),
	on(updateIncludePublic, (state, action) =>
		state.setLoading(true).toggleIncludePublicProjects(action.includePublic)
	)
);
